import styled from "styled-components";
import {GameHeaderBarRootBaseBox} from "../../../../common/boxes/root/game-header-bar-root-base.box";

export const GamePlayMobileHeaderBarRootBox = styled(GameHeaderBarRootBaseBox)`
    font-size: 1rem;
    padding: 2px;
    color: ${props => props.theme.colors.text};
    
`